interface Props {
  rating: number;
}

function tier(rating: number): { label: string; classes: string } | null {
  if (rating >= 8.0) {
    return { label: "Šedevras · TOP 1%", classes: "bg-amber-100 text-amber-800 ring-amber-200" };
  }
  if (rating >= 7.5) {
    return { label: "Klasika · TOP 5%", classes: "bg-emerald-100 text-emerald-800 ring-emerald-200" };
  }
  if (rating >= 7.0) {
    return { label: "Mėgstamas · TOP 15%", classes: "bg-blue-100 text-blue-800 ring-blue-200" };
  }
  if (rating >= 6.5) {
    return { label: "Solidus", classes: "bg-gray-100 text-gray-700 ring-gray-200" };
  }
  return null;
}

export function RatingContextBadge({ rating }: Props) {
  const t = tier(rating);
  if (!t) return null;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${t.classes}`}
    >
      {t.label}
    </span>
  );
}
